"use client";

import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CategorySubcategory from "@/components/Faq/FAQCategorySubcategory";

interface RentToBuyFaqModalProps {
    sectionsRentToBuy: any;
}

export default function RentToBuyFaqModal({ sectionsRentToBuy }: RentToBuyFaqModalProps) {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <span className="text-primary font-medium hover:underline cursor-pointer">Scoprilo qui</span>
            </DialogTrigger>
            <DialogContent className="sm:max-w-4xl max-w-[95vw] sm:max-h-[85vh] max-h-[90vh] overflow-y-auto">
                <DialogHeader className="mb-4">
                    <DialogTitle className="text-4xl font-bold">FAQ</DialogTitle>
                    <DialogDescription className="text-base text-gray-600">
                        Tutto quello che devi sapere sull'iniziativa
                    </DialogDescription>
                </DialogHeader>
                <div>
                    {(sectionsRentToBuy as any[])?.length > 0 && (sectionsRentToBuy as any[])[0].categories?.map((category: any) => (
                        <CategorySubcategory
                            key={category._id}
                            title={category.title}
                            slug={category.slug}
                            slugSezione={(sectionsRentToBuy as any[])[0].slug}
                            faqs={category.faqs}
                        />
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
